<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="saveUploads()">
    <i [hidden]="!loadingUploads" class="material-icons rotate text-muted">loop</i>
    <div class="card-body">
      <div class="row">
        <div class="col-12">

          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center" style="font-size: 1.1rem;">
              Uploads
              <label class="btn btn-link" style="margin-top: 9px;">
                <input type="file" hidden="hidden" multiple #fileInput accept="image/*,.pdf,.docx" (change)="changedFile(fileInput)" />
                Add Files
              </label>
            </div>
            <div class="col-8">
              <div *ngIf="form">
                <div formArrayName="uploads">
                  <div *ngFor="let u of getUploads(); let i=index;" class="mt-2" [formGroupName]="i">
                    {{u.value.fileName}}
                    <i class="fal fa-fw fa-trash pointer" style="color: red;" (click)="removeUpload(i)" title="Remove File"></i>
                  </div>
                </div>
                <div formArrayName="uploadedFiles">
                  <div *ngFor="let u of getUploadedFiles(); let i=index;" class="mt-2" [formGroupName]="i">
                    {{u.value.name}}
                    <i class="fal fa-fw fa-trash pointer" style="color: red;" (click)="removeUploaded(i)" title="Remove Added File"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col-5 text-left pl-0">
        <i class="material-icons rotate text-muted" *ngIf="disableButtons">loop</i>
        <button class="btn btn-secondary ml-2" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col-2 text-center"></div>
      <div class="col-5 text-right pr-0">
        <button class="btn btn-primary" type="submit" (click)="saveUploads()" [disabled]="disableButtons">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
